var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useRef, useState } from "react";
import { Button, ThemeModal } from "../../../index";
var DisplayV2Theme = forwardRef(function (_a, ref) {
    var id = _a.id, className = _a.className, style = _a.style, otherProps = __rest(_a, ["id", "className", "style"]);
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var buttonRef = useRef(null);
    var onClose = function () {
        setIsOpen(false);
        if (buttonRef.current) {
            buttonRef.current.focus();
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { ref: buttonRef, "aria-controls": id, className: "fr-btn--display", onClick: function () { return setIsOpen(true); }, type: "button" }, "Param\u00E8tres d'affichage"),
        isOpen ? (React.createElement(ThemeModal, __assign({}, otherProps, { ref: ref, className: className, style: style, id: id, onClose: onClose }))) : undefined));
});
export default DisplayV2Theme;
